
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"16.804","height":"19.14"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Grupo 1095"}},[_c('g',{attrs:{"data-name":"Grupo 430","stroke":"#0f587f","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.3"}},[_c('path',{attrs:{"data-name":"Trazado 202","d":"M6.07 5.125H1.94l.97 12.251a1.121 1.121 0 001.118 1.118h8.749a1.121 1.121 0 001.118-1.118l.968-12.247H6.07z","fill":"#f1f1f1"}}),_c('path',{attrs:{"data-name":"Trazado 203","d":"M10.589.65H6.07a1.2 1.2 0 00-1.191 1.192v1.047h6.9V1.842A1.2 1.2 0 0010.589.65z","fill":"#f1f1f1"}}),_c('path',{attrs:{"data-name":"Trazado 204","d":"M15.039 2.889H1.765a1.118 1.118 0 000 2.235h13.271a1.118 1.118 0 000-2.235z","fill":"#f1f1f1"}}),_c('path',{attrs:{"data-name":"Línea 66","fill":"none","d":"M8.293 7.458v8.7"}}),_c('path',{attrs:{"data-name":"Línea 67","fill":"none","d":"M11.455 7.458l-.344 8.7"}}),_c('path',{attrs:{"data-name":"Línea 68","fill":"none","d":"M5.202 7.458l.344 8.7"}})])])])
          )
        }
      }
    